import React from 'react';
import { LineKeySpec } from './discoveryModel';

/**
 * The line under the part's name: ids, then its key specs as one compact run
 * ("3S · 11.1V · 5200mAh · 30C · qty 1") with the spec that alternatives
 * differ on emphasised. A line whose wording states no key spec shows its
 * description instead.
 */
interface LineSpecSummaryProps {
  partNumber?: string;
  mpn?: string;
  keySpecs: LineKeySpec[];
  /** Spec keys to emphasise ("dischargeRate"). */
  emphasis: ReadonlySet<string>;
  description?: string;
  quantity?: number;
}

const Dot = () => <span aria-hidden> · </span>;

export const LineSpecSummary: React.FC<LineSpecSummaryProps> = ({ partNumber, mpn, keySpecs, emphasis, description, quantity }) => {
  const ids = [partNumber, mpn && `MPN ${mpn}`].filter(Boolean) as string[];
  const parts: React.ReactNode[] = [
    ...ids.map((id) => (
      <span key={`id-${id}`} className="font-mono">
        {id}
      </span>
    )),
    ...(keySpecs.length > 0
      ? keySpecs.map((spec) => (
          <span key={spec.key} className={emphasis.has(spec.key) ? 'font-bold text-ink' : undefined} title={spec.label}>
            {spec.text}
          </span>
        ))
      : description
        ? [<span key="description">{description}</span>]
        : []),
    ...(quantity != null ? [<span key="qty">qty {quantity}</span>] : []),
  ];
  if (parts.length === 0) return null;
  return (
    <div className="mt-[3px] text-body-sm text-ink-secondary">
      {parts.map((part, i) => (
        <React.Fragment key={i}>
          {i > 0 && <Dot />}
          {part}
        </React.Fragment>
      ))}
    </div>
  );
};

export default LineSpecSummary;
